import { inject, Injectable } from '@angular/core';
import { TokenPayload, UserAdminToken } from '../models/token.models';
import { TokenDecodifierService } from '../token-decodifier-service/token-decodifier-service';

@Injectable({
    providedIn: 'root'
})
export class JwtUtil {

    private tokenDecodifierService = inject(TokenDecodifierService);

    decodeJwt<T = TokenPayload>(token: string): T {
        return this.tokenDecodifierService.decode(token) as unknown as T;
    }

    getUserFromToken(token: string): UserAdminToken {

        const decoded = this.decodeJwt<any>(token);

        return {
            name: decoded['name'] || '',
            fullName: decoded['fullName'] || decoded['name'] || '',
            email: decoded['email'] || '',
            department: decoded['department'] || '',
            permissions: typeof decoded['permissions'] === 'string' ? decoded['permissions'].split(',') : [],
            exp: decoded['exp'] || 0,
            iat: decoded['iat'] || 0,
            active: decoded['active'] || false,
            id: decoded['id'] || decoded['sub'] || 0,
            userId: decoded['userId'] || decoded['id'] || 0,
            user_type: decoded['user_type'],
            is_user_inclub: decoded['is_user_inclub'],
            picture: decoded['picture'] || decoded['avatar'],
            avatar: decoded['avatar'] || decoded['picture'],
            documentType: decoded['documentType'],
            documentNumber: decoded['documentNumber']
        };
    }

    getExpirationDate(token: string): number {
        const decoded = this.decodeJwt<TokenPayload>(token);
        return decoded.exp;
    }
}
